module.exports = __webpack_public_path__ + "img/cibc.6f665be1.png";